import React, { Component } from 'react';
import { FormGroup, FormControl, ControlLabel, Col, Row, Checkbox, Panel } from 'react-bootstrap';
import {connect} from 'react-redux';
import BasicValidation from '../validation/basicValidation';

import { updateBasicInfo } from '../actions';
import FormSectionStatus from './FormSectionStatus';
import { ethnicities } from '../config/constants';

class BasicInfo extends Component {
  constructor(props){
    super(props);
    this.handlePersonalEmailChange = this.handlePersonalEmailChange.bind(this);
  }

  handlePersonalEmailChange(e){
    const {dispatch} = this.props;
    let updates = {};
    updates[e.target.id] = e.target.value;
    dispatch(updateBasicInfo(updates));
  }

  render() {
    const { basicInfo } = this.props;
    const validationStatus = new BasicValidation().getValidationStatus(basicInfo);
    const mappedEthnicities = ethnicities.map((ethnicity, index) => ({ name: ethnicity, checked: basicInfo.ethnicity.charAt(index) === 'Y', id: index}));
    const renderEthnicities = () => {
      return (
        <Row>
          <FormGroup>
            <Col md={12}>
              <ControlLabel>Ethnicity</ControlLabel>
            </Col>
            <Col md={4}>
              {mappedEthnicities.filter((ethnicity, index) => index % 3 === 0).map(
                ethnicity => <Checkbox key={ethnicity.id} checked={ethnicity.checked} disabled>{ethnicity.name}</Checkbox>)}
            </Col>
            <Col md={4}>
              {mappedEthnicities.filter((ethnicity, index) => index % 3 === 1).map(
                ethnicity => <Checkbox key={ethnicity.id} checked={ethnicity.checked} disabled>{ethnicity.name}</Checkbox>)}
            </Col>
            <Col md={4}>
              {mappedEthnicities.filter((ethnicity, index) => index % 3 === 2).map(
                ethnicity => <Checkbox key={ethnicity.id} checked={ethnicity.checked} disabled>{ethnicity.name}</Checkbox>)}
            </Col>
          </FormGroup>
        </Row>
      )
    };
    return (
      <div>
        <h2>Basic Information</h2>
        <Panel>
        <p>
          If any of the demographic information below is not correct, please update your information with Admissions and Records or email
          us at <a href="mailto:healthscienceapps@deltacollege.edu">healthscienceapps@deltacollege.edu</a>
        </p>
        <hr/>
        <Row>
          <Col md={4}>
            <FormGroup>
              <ControlLabel>
                Delta Id
              </ControlLabel>
              <FormControl.Static>
                {basicInfo.deltaId}
              </FormControl.Static>
            </FormGroup>
          </Col>
          <Col md={4}>
            <FormGroup>
              <ControlLabel>
                Gender
              </ControlLabel>
              <FormControl.Static>
                {basicInfo.gender}
              </FormControl.Static>
            </FormGroup>
          </Col>
          <Col md={4}>
            <FormGroup>
              <ControlLabel>
                Student Email
              </ControlLabel>
              <FormControl.Static>
                {basicInfo.email}
              </FormControl.Static>
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <FormGroup>
              <ControlLabel>
                First Name
              </ControlLabel>
              <FormControl.Static>
                {basicInfo.name.firstName}
              </FormControl.Static>
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup>
              <ControlLabel>
                Last Name
              </ControlLabel>
              <FormControl.Static>
                {basicInfo.name.lastName}
              </FormControl.Static>
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <FormGroup>
              <ControlLabel>
                Street Address
              </ControlLabel>
              <FormControl.Static>
                {basicInfo.address.address1}
              </FormControl.Static>
            </FormGroup>
          </Col>
          <Col md={3}>
            <FormGroup>
              <ControlLabel>
                City
              </ControlLabel>
              <FormControl.Static>
                {basicInfo.address.city}
              </FormControl.Static>
            </FormGroup>
          </Col>
          <Col md={1}>
            <FormGroup>
              <ControlLabel>
                State
              </ControlLabel>
              <FormControl.Static>
                {basicInfo.address.state}
              </FormControl.Static>
            </FormGroup>
          </Col>
          <Col md={2}>
            <FormGroup>
              <ControlLabel>
                Zip Code
              </ControlLabel>
              <FormControl.Static>
                {basicInfo.address.zip}
              </FormControl.Static>
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <FormGroup>
              <ControlLabel>
                Contact Phone Number
              </ControlLabel>
              <FormControl.Static>
                {basicInfo.phones[0].number}
              </FormControl.Static>
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup
              controlId="personalEmail"
              validationState={validationStatus.personalEmail}
            >
              <ControlLabel>
                Personal Email
              </ControlLabel>
              <FormControl
                componentClass="input"
                type="text"
                value={basicInfo.personalEmail}
                placeholder="Enter Personal Email"
                onChange={this.handlePersonalEmailChange}
              />
              <FormControl.Feedback />
            </FormGroup>
          </Col>
        </Row>
        {renderEthnicities()}
        </Panel>
        <FormSectionStatus {...validationStatus.section}/>
      </div>
    );
  };
}

export default connect(
  (state) => {
    return state;
  }
)(BasicInfo);